/**
 * Csv Schema of CargaFoto
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaFoto} from '@/model/resource/CargaFoto'

/* TODO: review generated schema */
export class CsvCargaFotoSchema extends Schema {
  readonly name = 'CsvCargaFoto'

  readonly fieldSet: FieldSet<CargaFoto> = {
    idFotoPk: schema => schema.model.idFotoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    urlImagem: schema => schema.model.urlImagem,
    ehOcorrencia: schema => Helper.bool(schema.model.ehOcorrencia),
    reprocessar: schema => Helper.bool(schema.model.reprocessar),
    urlBackup: schema => schema.model.urlBackup,
  }
}
